export const RNWelcome = '/welcome'
export const RNHome = '/'
export const RNMechanic = '/mechanic'
export const RNElectric = '/electric'
export const RNUsers = '/users'
export const RNProfile = '/profile'
export const RNRelay = '/relay'
export const RNChecks = '/checks'
export const RNChecksMechanic = '/checks/mechanic'
export const RNChecksElectric = '/checks/electric'
export const RNJournal = '/journal'
export const RNLogin = '/login'
export const RNRegister = '/register'
export const RNLogout = '/logout'
export const RNNotFound = '/404'
export const RNSuccess = '/success'

export const RNRelayType = '/relay-type'
export const RNCreateRelayType = '/relay-type/create'
export const RNEditRelayType = '/relay-type/edit'
export const RNCreateRelay = '/relay/create'
export const RNEditRelay = '/relay/edit'
export const RNRelayOne = '/relay-one'
export const RNRelayOneCharacteristic = '/relay-one/characteristic'
export const RNRelayOneRecords = '/relay-one/records'
export const RNCreateRelayOneRecord = '/relay-one/record/create'
export const RNCreateRelayOne = '/relay-one/create'

export const RNLearning = '/learning'
export const RNLearningDetail = '/learning/:id'
export const RNLearningFavorites = '/learning/favorites'
export const RNLearningAdmin = '/learning/admin'
